<template lang="pug">
.content-part
    .gencode
        .gencode-select
            domain-select(tip="该功能仅用于基础流量代码自动安装", @change="onDomainChange")
            .install-status
                | 网站 {{ domain.domain | truncate }} 自动安装代码
                .install-status-success(v-show="pageStatus == 'installEnd'")
                    i.fa.fa-check-circle
                    | 安装成功
                    span(v-show="showRollback") , 您可以在 {{end_time}} 之前恢复网站。
                .action-recover(v-show="pageStatus == 'installEnd'")
                    a.btn.btn-primary.btn-big(v-show="showRollback", @click="rollback") 恢复原网站
                .install-status-failed(v-show="pageStatus == 'errorEnd'")
                    i.fa.fa-exclamation-circle 
                    | 安装失败，请重新安装

        div
            .gencode-index
                span.gen-index ①
                span.gen-text 连接FTP服务器
                v-tooltip(
                    class="gencode-tooltip",
                    tip="您可以向网站管理员、托管公司询问FTP用户名和密码；输入FTP相关信息即可进行代码自动安装，我们不会记录您FTP用户名和密码，请放心使用。",
                    pos="right"
                )
                    i.fa.fa-question-circle
            
            .form
                v-form-item(label="FTP地址：")
                    input.size-big(v-model="ftpInfo.ftpaddr")
                    em.error(v-if="!ftpInfoState.ftpaddr") 请填写FTP地址

                v-form-item(label="用户名：")
                    input(v-model="ftpInfo.ftpuser")
                    em.error(v-if="!ftpInfoState.ftpuser") 请填写用户名
                    
                v-form-item(label="密码：")
                    input(v-model="ftpInfo.ftppwd", type="password")
                    em.error(v-if="!ftpInfoState.ftppwd") 请填写密码
                
                label.spread-opts(@click="toggleFTPOption")
                    | 高级选项
                    i.fa(:class="[useOption ? 'fa-angle-down' : 'fa-angle-right']")

                .item.spread-items(v-show="useOption")
                    .label 初始目录：
                    input(v-model="ftpOption.ftpdirs")
                    .label  端口号：
                    input.size-small(v-model="ftpOption.ftpport")
                    v-checkbox(v-model="ftpOption.is_ssl", title=" 开启SSL", style="margin-left: 20px;")

                v-form-item(v-if="!treeRootData")
                    button.btn.btn-primary.btn-small(type="submit", @click="connectFTP") 连接
                    em.error(v-if="ftpError")
                        i.fa.fa-info-circle(style="margin-right: 5px;")
                        | {{ftpError}}
                
                p(v-if="treeRootData", style="color: #56bf8b; line-height: 30px;")
                    i.fa.fa-check-circle(style="margin-right: 5px;")
                    | 成功链接服务器


            .gencode-index
                span.gen-index ②
                span.gen-text 设置安装目录
                v-tooltip(
                    class="gencode-tooltip",
                    tip="请在下方选择监测代码的安装目录，我们会为您选择的目录下的文件添加监测代码。",
                    pos="right"
                )
                    i.fa.fa-question-circle
                p(style="line-height: 40px;") 安装路径：

                v-folder(
                    v-if="treeRootData",
                    :conf="treeDataConf",
                    :data="treeRootData",
                    :ajax="treeAjaxConf",
                    @change="onFolderChange"
                )
                
                .btn.btn-primary.btn-medium(:class="{ disabled: !treeRootData, 'start-install': treeRootData }", @click="startInstall") 开始安装
    
    div.modal-groups(v-show="showMaskPanel")
        .modal-item(v-for="modal in modalConfig", v-show="modal.status === pageStatus")
            .modal-item--content
                .content-header {{modal.title}}
                hr
                .content-desc  {{modal.content}}
                .btn-wrap(v-if="modal.btns && modal.btns.length")
                    button.btn.btn-big(
                        v-for="btn in modal.btns",
                        @click="btn.click",
                        :class="'btn-' + (btn.type || 'primary')"
                    ) {{btn.text}}

    // div.modal-groups(v-show="false")
    //     v-modal(
    //         v-for="modal in modalConfig",
    //         :visible="modal.status === pageStatus",
    //         :title="modal.title"
    //     )
    //         .modal-content {{modal.content}}
    //         .btn-wrap(v-if="modal.btns && modal.btns.length")
    //             button.btn.btn-medium(
    //                 v-for="btn in modal.btns",
    //                 @click="btn.click",
    //                 :class="'btn-' + (btn.type || 'primary')"
    //             ) {{btn.text}}
</template>

<script>
    import Vue from 'vue';
    import Base64 from 'base64-url';
    import VFolder from 'v-folder/dist/build';
    Vue.use(VFolder);

    import CodeInstall from './codeInstall.mixin.js';

    const initialState = {
        ftpInfo: {
            ftpaddr: '',
            ftpuser: '',
            ftppwd: ''
        },
        ftpInfoState: {
            ftpaddr: true,
            ftpuser: true,
            ftppwd: true
        },
        useOption: false,
        ftpOption: {
            ftpdirs: '',
            ftpport: '',
            is_ssl: false
        },
        ftpError: '',
        selectedFolders: [],
        treeRootData: null,
        treeDataConf: {
            node: 'sourceDir'
        }
    };

    export default {
        mixins: [CodeInstall],
        data() {
            return _.cloneDeep(initialState);
        },

        computed: {
            domain() {
                return this.$store.state.currentDomain;
            },
            treeAjaxConf() {
                return {
                    method: 'GET',
                    url: '/api/ftp/dircheck',
                    params: this.getFtpParams(),
                    pathAs: 'ftpdirs',
                    process: r => r.data
                }
            }
        },
        watch: {
            pageStatus(newVal) {
                let toInitial = ['rollbackEnd', 'cancelEnd'].indexOf(newVal) > -1;
                let state = _.cloneDeep(initialState);
                if (toInitial) {
                    Object.keys(state).forEach((key) => {
                        this[key] = state[key];
                    });
                }
            }
        },

        methods: {
            // 用于提交
            getFtpParams() {
                let trim = _.trim;
                let { ftpaddr, ftpuser, ftppwd } = this.ftpInfo;
                let { ftpdirs, ftpport, is_ssl } = this.ftpOption;
                return {
                    ftpaddr: trim(ftpaddr),
                    ftpuser: trim(ftpuser),
                    ftppwd: Base64.encode(trim(ftppwd)),
                    ftpdirs: ftpdirs,
                    ftpport: trim(ftpport),
                    is_ssl: is_ssl ? 1 : 0,
                    domainId: this.domain.id
                };
            },

            // 高级选项
            toggleFTPOption() {
                this.useOption = !this.useOption;
                if (!this.useOption) {
                    this.ftpOption.ftpdirs = '';
                    this.ftpOption.ftpport = '';
                    this.ftpOption.is_ssl  = false;
                }
            },

            // FTP 信息校验
            validateFTPInfo() {
                let ftpInfo  = this.ftpInfo;
                let ftpInoState = this.ftpInfoState;
                let isValid  = true;

                _.each(['ftpaddr', 'ftpuser', 'ftppwd'], (key) => {
                     let valid = !!_.trim(ftpInfo[key]) ? true : false;
                     ftpInoState[key] = valid;

                     if (!valid) {
                         isValid = false;
                     }
                });

                return isValid;
            },

            // 连接 FTP
            connectFTP() {
                let isValid = this.validateFTPInfo();
                if (!isValid) return;

                this.$http.get('/api/ftp/dircheck', {
                    params: this.getFtpParams()
                }).then(res => {
                    let data = res.data;

                    this.ftpError = !data.errno ? void 0 : (
                        _.get([
                            '请检查 ftp 地址， 端口号，ssl 方式（查看 端口号和ssl 方式请点击高级选项）',
                            '请检查 用户名，密码，ssl 方式（查看 ssl 方式请点击高级选项）',
                            'ftp目录不存在,请检查 初始目录（查看 初始目录 请点击高级选项）'
                        ], data.errno - 1) || data.errmsg
                    );
                    
                    this.treeRootData = data.errno ? null : data.data;
                }).catch((e) => {
                    this.ftpError = '连接失败， 请重新连接';
                });
            },

            onFolderChange(res) {
                this.selectedFolders = res;
            },

            onDomainChange() {
                this.initStatusCheck();
            },

            // 开始安装
            startInstall() {
                if (!this.treeRootData) return;

                if (!this.selectedFolders.length) {
                    return this.$Modal.warn('请选一个目录，否则无法开始安装');
                }
                this.changeStatusTo('installing');
            }
        },
        filters: {
            truncate(value, len = 20) {
                return value.length <= len ? value : value.slice(0, 20) + '...';
            }
        }
    }
</script>

<style scoped>
@import '../../css/base/variables.css';

.gencode {
    padding: 0 0 30px 0;
}
.spread-opts {
    width: 70px;
    margin-bottom: 0.84em;
    line-height: 2.5;
    cursor: pointer;
    color: var(--Green);

    & > .fa {
        font-weight: bold;
        margin-left: 10px;
        transform: scale(1.4);
    }
}
.spread-items .label {
    float: none;
    display: inline-block;
}

.install-status {
    height: 45px;
    background: #f5f8fb;
    line-height: 45px;
    padding-left: 20px;
}
.install-status-success,
.install-status-failed {
    display: inline-block;
    margin-left: 40px;
    color: var(--Green);
    & > .fa {
        margin-right: 5px;
    }
}
.install-status-success {
    color: var(--Green);
}
.install-status-failed {
    color: var(--Red);
}
.action-recover {
    float: right;
    line-height: 45px;
    height: 45px;
    margin-right: 20px;
}

/*modals*/
.modal-groups {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
}

.modal-item--content {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2050;
    padding: 20px 40px;
    width: 499px;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background: #fff;
    text-align: center;
}
.content-header {
    padding-top: 10px;
    font-size: 18px;
    color: #384b66;
}
hr {
    margin-top: 12px;
    margin-bottom: 12px;
    border: 0;
    border-top: 1px solid #eeeeee;
    background-color: white;
}
.content-desc {
    font-size: 14px;
    color: #738699;
}
.btn-wrap {
    padding: 20px 0 10px 0;
}
.start-install {
    margin-top: 20px;
}
</style>

<style>
.modal-groups .modal-hd > .close {
    display: none;
}
.v-branch-body {
    color: #999!important;
    font-size: 13px!important;
}
.v-branch-body .fa {
    color: #999!important;
}
.v-branch-body .fa:hover {
    color: #999!important;
}
.v-node > .fa-folder-open-o:before {
    content: "\f07c"!important;
}
.v-node > .fa-folder-o:before {
    content: "\f07b"!important;
}

.gencode-tooltip > .fa {
    margin-right: 8px;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// gencode_install.vue?37873b5f